<template>
  
    <div class="container is-fluid  p-5">
      <h1 class="title">Phone Calls</h1>
      <hr />

    <div v-if="sipStatus.callstatus !== 2" class="notification is-warning is-light has-text-centered mb-4">
      <strong>Disconnected:</strong> Call handling is disabled until you establish a connection.
    </div>

      <div class="columns is-multiline">
        <!-- Caller List -->
        <div class="column is-9">
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="box">
                <h2 class="subtitle">Ringing Callers</h2>
                <table class="table is-fullwidth is-hoverable">
                  <thead>
                    <tr>
                      <th>Caller ID</th>
                      <th>Number</th>
                      <th>State</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="caller in ringing_callers" :key="caller.id">
                      <td>{{ caller.caller_name || 'Unknown' }}</td>
                      <td>{{ caller.caller_number }}</td>
                      <td>
                          <span class="tag is-small" :class="mapCallStatus(caller.state).class">
                            {{ mapCallStatus(caller.state).label }}
                          </span>
                      </td>
                      <td>
                        <div class="buttons are-small">
                          <button 
                            @click="talkToCaller(caller.id)" 
                            class="button is-primary"
                            :disabled="disableCallHandling(caller.id)"
                          >
                            Audition
                          </button>
                          <button 
                            @click="callerOnAir(caller.id)" 
                            class="button is-primary"
                            :disabled="disableCallHandling(caller.id)"
                          >
                            Go to Air
                          </button>
                          <button 
                            @click="callerHold(caller.id)" 
                            class="button is-primary"
                            :disabled="disableCallHandling(caller.id)"
                          >
                            Hold
                          </button>                                         
                        </div>
                      </td>
                    </tr>
                    <tr v-if="ringing_callers.length === 0">
                      <td colspan="4" class="has-text-centered has-text-grey">
                        No callers wiating to be answered.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>          
            </div>            
            <div class="column is-6">
              <div class="box">
                <h2 class="subtitle">Callers On-Hold</h2>
                <table class="table is-fullwidth is-hoverable">
                  <thead>
                    <tr>
                      <th>Caller ID</th>
                      <th>Number</th>
                      <th>State</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="caller in callers" :key="caller.id">
                      <td>{{ caller.caller_name || 'Unknown' }}</td>
                      <td>{{ caller.caller_number }}</td>
                      <td>
                          <span class="tag is-small" :class="mapCallStatus(caller.state).class">
                            {{ mapCallStatus(caller.state).label }}
                          </span>
                      </td>
                      <td>
                        <div class="buttons are-small">
                          <button 
                            @click="talkToCaller(caller.id)" 
                            class="button is-primary"
                            :disabled="disableCallHandling(caller.id)"
                          >
                            Audition
                          </button>
                          <button 
                            @click="callerOnAir(caller.id)" 
                            class="button is-primary"
                            :disabled="disableCallHandling(caller.id)"
                          >
                            Go to Air
                          </button>
                          <button 
                            @click="hangupCall(caller.id)" 
                            class="button is-danger"
                          >
                            Hang Up
                          </button>                          
                        </div>
                      </td>
                    </tr>
                    <tr v-if="callers.length === 0">
                      <td colspan="4" class="has-text-centered has-text-grey">
                        No callers currently in queue.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>     
          </div>
        </div>

        <!-- Active Call Controls -->
        <div class="column is-3">
          <!-- PERSISTENT AUDIO SETTINGS BOX (Always Visible) -->
          <div class="box mb-4">
            <div class="is-flex is-justify-content-space-between is-align-items-center mb-3">
              <h2 class="subtitle is-6 mb-0">Audio Processing</h2>
              <span class="tag is-info is-light">Global</span>
            </div>
            <div class="columns is-mobile">
              <div class="column">
                <button 
                  @click="callerAudioStore.toggle('agc')" 
                  class="button is-small is-fullwidth" 
                  :class="callerAudioStore.agc ? 'is-success' : 'is-light'"
                >
                  AGC: {{ callerAudioStore.agc ? 'ON' : 'OFF' }}
                </button>
              </div>
              <div class="column">
                <button 
                  @click="callerAudioStore.toggle('denoise')" 
                  class="button is-small is-fullwidth" 
                  :class="callerAudioStore.denoise ? 'is-success' : 'is-light'"
                >
                  NR: {{ callerAudioStore.denoise ? 'ON' : 'OFF' }}
                </button>
              </div>
            </div>            
          </div>
          <div class="box" v-if="activeExtCall">
            <h2 class="subtitle has-text-success">
              <span v-if="activeExtCall.type === 'BRIDGE_BROADCAST'">Caller On-Air</span>
              <span v-if="activeExtCall.type === 'BRIDGE_TALK'">Auditioning Caller</span>
            </h2>

            <!-- Hangup state -->
            <div v-if="(activeExtCall.hangup || false) == true">
              <p>Caller <strong>{{ activeExtCall?.channel?.caller_number }}</strong> hung up!</p>
              <button @click="requeueCaller(activeExtCall.channel.id)" class="button is-warning is-fullwidth mt-4">
                Return to Broadcast
              </button>
            </div>

            <!-- Active state -->
            <div v-if="(activeExtCall.hangup || false) == false">
              <p class="mb-3">Auditioning: <strong>{{ activeExtCall?.channel?.caller_number }}</strong></p>
              
              <!-- columns is-multiline wraps to next row; is-mobile keeps it horizontal -->
              <div class="columns is-mobile is-multiline is-variable is-1">
                
                <div class="column is-6">
                  <button @click="requeueCaller(activeExtCall.channel.id)" class="button is-warning is-fullwidth is-small">
                    Hold
                  </button>
                </div>

                <!-- 2. On-Air / Audition Toggle -->
                <div class="column is-6">
                  <button v-if="activeExtCall.type === 'BRIDGE_TALK'"
                          @click="callerOnAir(activeExtCall.channel.id)" 
                          class="button is-warning is-fullwidth is-small">
                    To Air
                  </button>
                  <button v-if="activeExtCall.type === 'BRIDGE_BROADCAST'"
                          @click="talkToCaller(activeExtCall.channel.id)" 
                          class="button is-warning is-fullwidth is-small">
                    Audition
                  </button>
                </div>

                <!-- 3. Mute / Unmute -->
                <div class="column is-6">
                  <button v-if="activeExtCall.mute_status == false"
                          @click="muteCaller(activeExtCall.channel.id, true, 'in')" 
                          class="button is-danger is-fullwidth is-small">
                    Mute
                  </button>
                  <button v-if="activeExtCall.mute_status != false"
                          @click="muteCaller(activeExtCall.channel.id, false, 'both')" 
                          class="button is-primary is-fullwidth is-small">
                    Unmute
                  </button>
                </div>

                <!-- 4. Hang Up -->
                <div class="column is-6">
                  <button @click="hangupCall(activeExtCall.channel.id)" class="button is-danger is-fullwidth is-small">
                    Hang Up
                  </button>
                </div>

              </div>
            </div>
          </div>
        
          <div class="notification is-light" v-else>
            Select a caller to audition or go on-air.
          </div>
        </div>
      </div>
    </div>
  
</template>

<script setup>
import { watch, onMounted, computed } from 'vue';

import { getState, talkToCaller, requeueCaller, callerOnAir, hangupCall, callerHold } from '@/services/callmanager';
import { useCallerAudioStore } from '@/stores/callAudio';
import { muteCaller } from '@/services/callmanager';
import { webRTCService } from '@/services/connect'

const callerAudioStore = useCallerAudioStore();
const { callers, ringing_callers, activeExtCall } = getState();
const { sipStatus } = webRTCService();

const disableCallHandling = computed(() => {
  return (caller_id) => {
    // Are we connected to the bridge?
    if (sipStatus.value.callstatus !== 2) {
      return true
    } else {
      return false
    }
  }
  //activeExtCall?.channel?.id === caller.id
})

const stateMap = {
  'ringing': { label: 'Ringing', class: 'is-warning' },
  'on-air':  { label: 'Live',     class: 'is-danger' },
  'hold':    { label: 'On Hold',  class: 'is-info' },
  'audition':{ label: 'Audition',  class: 'is-warning' },
  'default': { label: 'Unknown',  class: 'is-light' }
};

const mapCallStatus = (state) => {
  return stateMap[state?.toLowerCase()] || stateMap.default;
};

onMounted(() => {
  callerAudioStore.fetchSettings();
});

</script>
